import { Drive } from './_drive';

window.DASHBOARD_DRIVES = {
    options: {

    },
    drives: {},
    init: function (options) {
        _.extend(window.DASHBOARD_DRIVES.options, options);
        window.DASHBOARD_DRIVES.listenForStartReplay();
        window.DASHBOARD_DRIVES.bindToReplaySpeedButtons();
    },
    // Pass a drive ID to start displaying it on the dashboard, listening
    // for updates and all the other bits which should happen when a drive is
    // selected.
    // It's safe to call this function even if a drive is already displayed.
    showDrive: function (drive) {
        window.POLYGONS.showSubdivision(drive.subdivision_id);
        if (drive.area_id) {
            Livewire.emit('addArea', drive.area_id);
        } else {
            console.warn('This drive does not have an area_id' . drive.id)
        }
        if (!window.DASHBOARD_DRIVES.drives[`drive_${drive.id}`]) {
            window.DASHBOARD_DRIVES.drives[`drive_${drive.id}`] = new Drive(drive);
        }
    },
    // The opposite of enableDrive - turn everything off and tidy up.
    hideDrive: function (drive) {
        if (window.DASHBOARD_DRIVES.drives[`drive_${drive.id}`]) {
            window.DASHBOARD_DRIVES.drives[`drive_${drive.id}`].remove();
            delete window.DASHBOARD_DRIVES.drives[`drive_${drive.id}`];
        }
    },
    listenForStartReplay: function () {
        Livewire.on('startDriveReplay', driveId => {
            console.log(`Received Event startDriveReplay for drive ${driveId}`);
            if (window.DASHBOARD_DRIVES.drives[`drive_${driveId}`] !== undefined) {
                window.DASHBOARD_DRIVES.drives[`drive_${driveId}`].stopReplay();
                window.DASHBOARD_DRIVES.drives[`drive_${driveId}`].setReplayDuration(window.DRIVE_DASHBOARD.options.playbackDuration);
                window.DASHBOARD_DRIVES.drives[`drive_${driveId}`].startReply();
            }
        });
    },
    getDriveWaypointStatusInfo(statusId) {
        if (window.DASHBOARD_DRIVES._waypointInfo[statusId] === undefined) {
            console.error(`Unrecognised Status ID ${statusId}`);
        }
        return window.DASHBOARD_DRIVES._waypointInfo[statusId];
    },
    _waypointInfo: {
        0: {
            name: 'Raw',
            imgSrc: '/images/marker-icon-dot-raw.png',
            icon: new L.icon({
                iconUrl: '/images/marker-icon-dot-raw.png',
                iconSize: [5, 5]
            })
        },
        1: {
            name: 'Other',
            imgSrc: '/images/marker-icon-dot-other.png',
            icon: new L.icon({
                iconUrl: '/images/marker-icon-dot-other.png',
                iconSize: [5, 5]
            })
        },
        2: {
            name: 'Ambiguous Location',
            imgSrc: '/images/marker-icon-dot-ambiguous-location.png',
            icon: new L.icon({
                iconUrl: '/images/marker-icon-dot-ambiguous-location.png',
                iconSize: [5, 5]
            })
        },
        3: {
            name: 'Too Close',
            imgSrc: '/images/marker-icon-dot-too-close.png',
            icon: new L.icon({
                iconUrl: '/images/marker-icon-dot-too-close.png',
                iconSize: [5, 5]
            })
        },
        4: {
            name: 'Added in Error',
            imgSrc: '/images/marker-icon-dot-added-in-error.png',
            icon: new L.icon({
                iconUrl: '/images/marker-icon-dot-added-in-error.png',
                iconSize: [5, 5]
            })
        },
        5: {
            name: 'Not on Way',
            imgSrc: '/images/marker-icon-dot-not-on-way.png',
            icon: new L.icon({
                iconUrl: '/images/marker-icon-dot-not-on-way.png',
                iconSize: [5, 5]
            })
        },
        6: {
            name: 'Outside Subdivision',
            imgSrc: '/images/marker-icon-dot-outside-subdivision.png',
            icon: new L.icon({
                iconUrl: '/images/marker-icon-dot-outside-subdivision.png',
                iconSize: [5, 5]
            })
        },
        100: {
            name: 'OK',
            imgSrc: '/images/marker-icon-dot-ok.png',
            icon: new L.icon({
                iconUrl: '/images/marker-icon-dot-ok.png',
                iconSize: [5, 5]
            })
        },
    },
    bindToReplaySpeedButtons: function () {
        jQuery('body').on('click', '.drive-replay-speed-button', function () {
            let $this = $(this);
            let duration = $this.data('duration'); // Miliseconds
            window.DRIVE_DASHBOARD.options.playbackDuration = duration;
            _.each(window.DASHBOARD_DRIVES.drives, function (thisDrive) {
                thisDrive.setReplayDuration(duration);
            })
        });
    }
}
